













































































import { computed, defineComponent, onMounted, PropType, ref } from '@nuxtjs/composition-api';
import { maxBy } from 'lodash-es';
import ProductDetailPopover from '~/components/pages/Product/Detail/ProductDetailPopover.vue';
import ProductStyleLabel from '~/components/pages/Product/ProductStyleLabel.vue';
import ProductWineColorLabel from '~/components/pages/Product/ProductWineColorLabel.vue';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import AppPrice from '~/components/partials/App/AppPrice.vue';
import ProducingAreaFlag from '~/components/partials/ProducingArea/ProducingAreaFlag.vue';
import ProductLabel from '~/components/partials/Product/ProductLabel.vue';
import { useStore } from '~/composables/useStore';
import { url } from '~/utils';
import { filterReviewRating } from '~/utils/modules/products';
import { ProductDetailWineSetItem, ProductVariantShow } from '~/types/modules/product';

export default defineComponent({
  components: {
    AppLink,
    AppIcon,
    AppPrice,
    AppImage,
    ProductLabel,
    ProducingAreaFlag,
    ProductDetailPopover,
    ProductStyleLabel,
    ProductWineColorLabel,
  },
  props: {
    data: {
      type: Object as PropType<ProductDetailWineSetItem>,
      required: true,
    },
    hasSize: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const store = useStore();

    /** 子商品情報 */
    const productVariant = ref<ProductVariantShow>();
    /** スタイルID */
    const styleId = ref<number>();

    const productDetailUrl = computed(() => {
      return url('ITEM_DETAIL', { code: props.data.code });
    });

    /** 最も高得点の評価誌情報 */
    const highestReviewMediumInfo = computed(() => {
      if (!productVariant.value?.review_medium_info) {
        return;
      }
      const { review_medium_info } = productVariant.value;

      /** スコア表示用変数 */
      const scoreListForDisplay = [
        { mark: 'WA', score: review_medium_info.wa_point ?? '' },
        { mark: 'WS', score: review_medium_info.ws_point ?? '' },
        { mark: 'JS', score: review_medium_info.js_point ?? '' },
        { mark: 'V', score: review_medium_info.v_point ?? '' },
        { mark: 'WE', score: review_medium_info.we_point ?? '' },
        { mark: 'D', score: review_medium_info.d_point ?? '' },
      ];

      /** スコアソート用変数 */
      const scoreListForSorting = [
        { mark: 'WA', score: review_medium_info.wa_sort ?? 0 },
        { mark: 'WS', score: review_medium_info.ws_sort ?? 0 },
        { mark: 'JS', score: review_medium_info.js_sort ?? 0 },
        { mark: 'V', score: review_medium_info.v_sort ?? 0 },
        { mark: 'WE', score: review_medium_info.we_sort ?? 0 },
        { mark: 'D', score: review_medium_info.d_sort ?? 0 },
      ];

      const maxValue = maxBy(scoreListForSorting, 'score');
      return scoreListForDisplay.find((item) => item.mark === maxValue?.mark);
    });

    /** 評価誌情報 */
    const reviewMediumInfo = computed(() => {
      if (highestReviewMediumInfo.value?.score == null) {
        return;
      }
      return highestReviewMediumInfo.value;
    });

    onMounted(async () => {
      try {
        // TODO: なるべくAPI叩きたくないので、set_itemsのレスポンスに評価誌情報やスタイルIDを返してもらう
        const ecDetailResponse = await store.dispatch('product/detail/fetchECProductDetail', {
          path: { code: props.data.code },
        });

        productVariant.value = ecDetailResponse.product_variants.find(({ id }) => id === props.data.productVariantId);
        styleId.value = ecDetailResponse.master_settings.style?.id;
      } catch {
        // 何もしない
      }
    });

    return {
      filterReviewRating,
      productDetailUrl,
      reviewMediumInfo,
      styleId,
    };
  },
});
